



























































import { Component, Vue, Watch } from 'vue-property-decorator';
import { mapState } from 'vuex';
import _ from 'lodash';
import CatalogDetailModal from '../modals/CatalogModal.vue';
import { Spinner } from 'vue-image-spinner2';

@Component({
    name: 'catalogs',
    data: function () {
        return {
            catalogsPage_: 1,
        };
    },
    components: {
        CatalogDetailModal,
        Spinner,
    },
    computed: {
        ...mapState('catalogs', ['allCatalogs', 'allCatalogsLoading', 'catalogsPerPage', 'catalogsPage', 'catalogsTotal']),
        ...mapState('catalogs', {
            allCatalogs: (state: any) => {
                const allCatalogs = state.allCatalogs.map((catalog: any) => {
                    return {
                        ...catalog,
                    };
                });
                return _.orderBy(allCatalogs, 'id', 'asc');
            },
        }),
    },
})
export default class Catalogs extends Vue {
    public allCatalogs!: any;
    public allCatalogsLoading!: any;
    public catalogsPerPage!: any;
    public catalogsPage!: any;
    public catalogsTotal!: any;
    private activeCatalogLoaded: boolean = false;
    public catalogsPage_!: any;
    public catalog_word_search: any = '';

    allCatalogsHeaders = [
        { thClass: 'th', key: 'id', label: 'No. Catálogo' },
        { thClass: 'th', key: 'title', label: 'Título' },
        { thClass: 'th', key: 'edit', label: '' },
    ];

    setUrlPage(page: any) {
        this.$router.push({
            path: 'catalogs',
            query: {
                ...this.$route.query,
                page,
            },
        });
        this.catalogsPage_ = page;
    }

    setUrlSort(ctx: any) {
        this.$router.push({
            path: 'catalogs',
            query: {
                ...this.$route.query,
                sortName: ctx.sortBy,
                sortValue: ctx.sortDesc ? 'desc' : 'asc',
            },
        });
    }

    setUrlSearch(search: string) {
        // @ts-ignore
        search = search.trim();
        this.$router.push({
            path: 'catalogs',
            query: {
                ...this.$route.query,
                search,
            },
        });
    }

    onOpenCatalogDetailModal(id: number | null = null) {
        this.$store.dispatch('catalogs/getOne', id);
        this.activeCatalogLoaded = true;
        setTimeout(() => {
            this.$bvModal.show('catalog-detail-modal');
        }, 400);
    }

    onEditCatalog(id: number) {
        this.$store.dispatch('catalogs/getOne', id);
        this.activeCatalogLoaded = true;
        setTimeout(() => {
            this.$bvModal.show('catalog-detail-modal');
        }, 400);
    }

    @Watch('$route')
    getAllCatalogs() {
        const page = this.$route.query.page || 1;
        const search = this.$route.query.search || null;
        this.$store.dispatch('catalogs/getAll', {
            page,
            search,
        });
    }

    mounted() {
        this.getAllCatalogs();
        this.catalogsPage_ = 1;
    }
}
